
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/rich-text.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-rich-text-demo-codehighlighter"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/rich-text.zh-CN.md?type=demo')
};